import { j as c } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ c.jsxs("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ c.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M22.594 11.496v-2.83A2.58 2.58 0 0 0 20.11 6.09V4.354c0-.905-.736-1.641-1.641-1.641h-4.517l-.583-1.621a1.63 1.63 0 0 0-.848-.93 1.63 1.63 0 0 0-1.257-.056L3.067 3.089c-.412.15-.741.452-.926.85s-.204.844-.053 1.256l.329.899A2.58 2.58 0 0 0 0 8.666v12.75a2.58 2.58 0 0 0 2.578 2.578h17.438a2.58 2.58 0 0 0 2.578-2.578v-2.923A1.64 1.64 0 0 0 24 16.869v-3.75c0-.825-.612-1.51-1.406-1.624m0 5.374a.234.234 0 0 1-.234.234h-3.75c-1.163 0-2.109-.946-2.109-2.109s.946-2.109 2.109-2.109h3.75c.129 0 .234.105.234.234zM3.409 4.711a.23.23 0 0 1 .008-.179.23.23 0 0 1 .132-.121l8.196-2.983a.236.236 0 0 1 .301.141l.412 1.145h-.317c-.905 0-1.641.736-1.641 1.641v1.734H3.913zm15.294-.357v1.734h-6.797V4.354c0-.129.105-.234.234-.234h6.328c.129 0 .234.105.234.234m1.313 18.234H2.578a1.174 1.174 0 0 1-1.172-1.172V8.666c0-.646.526-1.172 1.172-1.172h17.438c.646 0 1.172.526 1.172 1.172v2.813H18.61c-1.939 0-3.516 1.577-3.516 3.516s1.577 3.516 3.516 3.516h2.578v2.906c0 .646-.526 1.172-1.172 1.172"
    }
  ),
  /* @__PURE__ */ c.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M19.313 14.994a.703.703 0 0 1-.704.703.703.703 0 0 1-.703-.703.703.703 0 0 1 1.407 0"
    }
  )
] });
export {
  l as W
};
